import RecognitionDialog from "./RecognitionDialog";

export default RecognitionDialog;
